import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useOrders from "../../hooks/useOrders";
import { Button } from "src/business-types/grocery/components/Button";
import iconMap from "../../../../assets/icons/Icons";
import {
  getLedgersCustomer,
  getOrder,
  patchOrder,
} from "../../../../shared/services/services";
import LoadingScreen from "../../../../shared/components/LoadingScreen";
import { useUser } from "../../components/UserContext";
import { Order, Product } from "../../../../shared/services/interface";
import useSpecifiedLedger from "../../hooks/useSpecifiedLedger";
import { notifySuccess } from "../../../../assets/toastService";
import Print from "../../../../printConfigration/PrintConfigration";
import PopupModules from "src/features/auth/components/PopupModules";
import PaymentPopup from "./PaymentPopup";
import PaymentHistory from "./PaymentHistory";
import {
  ThemeBasedColorHeader,
  ThemeBasedColorMenubar,
} from "src/shared/modules/profile/theme/themeCheacker";
import Goback from "../../components/Goback";
import OrderSidePanal from "./OrderSidePanal";
import PaymentReverse from "./PaymentReverse";
import { errorHandling } from "src/shared/utils/errorHandling";
import InputBox from "../../components/InputBox";
import useUOM from "src/shared/hooks/useUOM";
import useProductsIndexDB from "../../hooks/useProductIndexDB";
import useCategory from "../../hooks/useCategory";
import ReturnReplace, { changeDetails } from "./ReturnReplace";

function SpecifiedOrderDisplay() {
  const { user } = useUser();
  const { orderid } = useParams();
  const { orderData, loadingOrder, setOrderData, putOrderData } = useOrders(
    "",
    orderid,
  );
  const order = orderData?.[0] || orderData;
  const [orderStatus, setOrderStatus] = useState<string>(
    order?.OrderStatus || "",
  );
  const [orderChange, setOrderChange] = useState<Order>();
  const EastIcon = iconMap["EastIcon"];
  const [payment, setPayment] = useState<boolean>(false);
  const [changeConfimation, setChangeConfimation] = useState<boolean>(false);
  const [lastOrderData, setLastOrderData] = useState<Order>();
  const [printData, setPrintData] = useState<string>("");
  const [history, setHistory] = useState<boolean>(false);
  const customerLedgerUrl = order?.Customerid
    ? `customer/${order.Customerid}`
    : "";
  const { ledgers, loading, setLedgers } =
    useSpecifiedLedger(customerLedgerUrl);
  const [totalSOB, setOSB] = useState<number>(0);
  const [payOnly, setPayOnly] = useState<boolean>(false);
  const [reversedPayment, setReceivedPayment] = useState<boolean>(false);
  const [enabileEdit, setEnableEdit] = useState<boolean>(false);
  const [editableProducts, setEditableProducts] = useState<Product[]>([]);
  const { uom } = useUOM();
  const { product, loadingPro, productSync } = useProductsIndexDB();
  const { category } = useCategory();
  const DeleteIcon = iconMap["Delete"];
  const [returnReplace, setReturnReplace] = useState<boolean>(false);
  const now = new Date();
  const localDate =
    now.getFullYear() +
    "-" +
    String(now.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(now.getDate()).padStart(2, "0");

  useEffect(() => {
    setOSB(ledgers?.total_outstanding_balance || 0);
  }, [ledgers]);

  useEffect(() => {
    setOrderChange(order);
    setEditableProducts(order.Products);
    // if (enabileEdit === false) {
    // }
  }, [order]);

  const calculateTotal = (item: Product) => {
    const base = Number(item.quantity || 0) * Number(item.amount || 0);

    const addOnTotal = (item.addOns || []).reduce(
      (sum, a) => sum + Number(a.amount || 0),
      0,
    );

    return base + addOnTotal;
  };

  useEffect(() => {
    if (orderChange?.Products && product?.length && uom?.length) {
      const formatted: Product[] = orderChange.Products.map((item: Product) => {
        const formattedItem: Product = {
          ...item,
          quantity: Number(item.quantity || 0),
          amount: Number(item.amount || 0),

          addOns: (item.addOns || []).map((a: any, index: number) => ({
            sNo: a.sNo ?? index + 1,
            text: a.text || "",
            amount: Number(a.amount || 0),
          })),

          originalQty: Number(item.quantity || 0),
          orderQty: item.orderQty ?? 0,
          modify: false,
        };

        return {
          ...formattedItem,
          totalPrice: calculateTotal(formattedItem), // ✅ correct total
        };
      });

      setEditableProducts(formatted);
    }
  }, [orderChange?.Products, product, uom, enabileEdit]);

  const statusChange = (value: string) => {
    setChangeConfimation(true);
    setOrderStatus(value);
  };

  const cancel = () => {
    setChangeConfimation(false);
    setPayment(false);
    setOrderStatus(order.OrderStatus);
    setReceivedPayment(false);
  };

  const callApi = (data?: any, openPrint?: string) => {
    const statusUpdate = data
      ? data
      : { OrderStatus: orderStatus, status_change: true };
    patchOrder(order.Orderid, statusUpdate)
      .then((res) => {
        notifySuccess("Order updated successfully");
        getLedger();
        reCallGetOrder(openPrint);
        cancel();
      })
      .catch((error) => {
        errorHandling(error);
      });
  };

  const reCallGetOrder = (openPrint?: string) => {
    getOrder(orderid).then((res) => {
      const orderData = res.data.result;
      setOrderData(orderData);
      if (openPrint) {
        setHistory(true);
        setLastOrderData(orderData);
        setPrintData(orderData._id.$oid);
        setPayOnly(false);
      }
    });
  };

  const finalAmount = Number(order?.Finalamount ?? 0);
  const alreadyPaid = (order.paymentHistory ?? []).reduce(
    (acc, item) => acc + Number(item?.ReceivedAmount || 0),
    0,
  );
  const adj = (order.paymentHistory ?? []).reduce(
    (acc, item) => acc + Number(item?.adjustAmount || 0),
    0,
  );

  const remaining = finalAmount - alreadyPaid - adj;

  const confirm = () => {
    if (["cancel", "return & refund"].includes(orderStatus?.toLowerCase())) {
      if (received === 0) {
        callApi();
      } else {
        setReceivedPayment(true);
      }
    } else if (orderStatus !== "Delivered") {
      callApi();
    } else if (orderStatus === "Delivered") {
      if (remaining >= 0) {
        callApi();
      } else {
        getLedger();
        setChangeConfimation(false);
        setPayment(true);
      }
    }
  };

  const getLedger = () => {
    getLedgersCustomer(order.Customerid)
      .then((res) => {
        setLedgers(res.data.ledger);
      })
      .catch((error) => console.log(error));
  };

  if (loading || loadingOrder) {
    return <LoadingScreen />;
  }

  const payments = (lastOrderData?.paymentHistory ?? []).reduce(
    (sum, item) => sum + Number(item?.ReceivedAmount || 0),
    0,
  );

  const PrintData = {
    CustomerName: lastOrderData?.CustomerName || "",
    CustomerPhon: lastOrderData?.CustomerPhoneNo || "",
    OrderId: lastOrderData?.Orderid || "",
    OrderStatus: lastOrderData?.OrderStatus || "",
    discount: Number(lastOrderData?.discount),
    Date: lastOrderData?.Orderdate || "",
    Time: lastOrderData?.Ordertime || "",
    Products: lastOrderData?.Products || [],
    Paid: payments || 0,
    unpaid: lastOrderData?.RemainingAmount || 0,
    total: lastOrderData?.totalAmount || "",
    subtotal: lastOrderData?.totalAmount
      ? lastOrderData.totalAmount - Number(lastOrderData?.discount)
      : 0,
    imglogo: user?.image_url,
    OSB: totalSOB,
    clientId: lastOrderData?.client_id || "",
    businessType: user?.business_type,
    payMentHistory: lastOrderData?.paymentHistory,
    payMentHistoryAvabile: true,
    billNo: lastOrderData?.billNumber,
    outstanding_balance: totalSOB,
    returnAmount: Number(lastOrderData?.balanceReturned || 0),
    paidAmount: lastOrderData?.paymentHistory[0].paidAmount || 0,
    ...(lastOrderData?.returnHistory && {
      returnProducts: lastOrderData.returnHistory.map((r) => r.items).flat(),
    }),
    sellerName: lastOrderData?.createdBy || "",
  };

  const received =
    order.paymentHistory?.reduce(
      (total, item) => total + Number(item.ReceivedAmount || 0),
      0,
    ) ?? 0;

  const remainingPrice = () => {
    const remaining = Math.max(0, order.Finalamount - received);
    return remaining.toFixed(2);
  };

  const handleProductChange = (
    index: number,
    field: "quantity" | "amount",
    value: string,
  ) => {
    setEditableProducts((prev) =>
      prev.map((item, i) => {
        if (i !== index) return item;

        const numericValue = Number(value) || 0;

        const updatedItem = {
          ...item,
          [field]: numericValue,
          modify: true,
        };

        return {
          ...updatedItem,
          totalPrice: calculateTotal(updatedItem), // ✅ FIX
        };
      }),
    );
  };

  // ✅ Add / Update AddOn
  const handleAddOnChange = (
    productIndex: number,
    addOnIndex: number,
    field: "text" | "amount",
    value: any,
  ) => {
    setEditableProducts((prev) =>
      prev.map((item, i) => {
        if (i !== productIndex) return item;

        const updatedAddOns = [...(item.addOns || [])];

        updatedAddOns[addOnIndex] = {
          ...updatedAddOns[addOnIndex],
          [field]: field === "amount" ? Number(value) : value,
        };

        return {
          ...item,
          addOns: updatedAddOns,
          totalPrice:
            Number(item.quantity || 0) * Number(item.amount || 0) +
            updatedAddOns.reduce((sum, a) => sum + Number(a.amount || 0), 0),
        };
      }),
    );
  };

  // ✅ Add new AddOn
  const handleAddAddOn = (productIndex: number) => {
    setEditableProducts((prev) =>
      prev.map((item, i) => {
        if (i !== productIndex) return item;

        const newAddOn = {
          sNo: String((item.addOns?.length || 0) + 1),
          text: "",
          amount: 0,
        };

        return {
          ...item,
          addOns: [...(item.addOns || []), newAddOn],
        };
      }),
    );
  };

  // ✅ Delete AddOn
  const handleDeleteAddOn = (productIndex: number, addOnIndex: number) => {
    setEditableProducts((prev) =>
      prev.map((item, i) => {
        if (i !== productIndex) return item;

        const updatedAddOns = [...(item.addOns || [])];
        updatedAddOns.splice(addOnIndex, 1);

        return {
          ...item,
          addOns: updatedAddOns,
          totalPrice:
            Number(item.quantity || 0) * Number(item.amount || 0) +
            updatedAddOns.reduce((sum, a) => sum + Number(a.amount || 0), 0),
        };
      }),
    );
  };

  const addProductToOrder = (productId: string) => {
    if (productId === "other") return;

    const selectedProduct = product.find((p) => p._id?.$oid === productId);
    if (!selectedProduct) return;

    setEditableProducts((prev) => {
      const existingIndex = prev.findIndex((p) => p.productId === productId);

      // ✅ Product already exists → increase quantity
      if (existingIndex !== -1) {
        const updated = [...prev];
        const qty = Number(updated[existingIndex].quantity) + 1;

        updated[existingIndex] = {
          ...updated[existingIndex],
          quantity: qty,
          totalPrice: qty * Number(updated[existingIndex].amount),
        };

        return updated;
      }

      // ✅ Product does not exist → add new
      const newProduct: Product = {
        productId: productId,
        productName: selectedProduct.ProductName,
        arabicword: selectedProduct.ArabicName,
        quantity: 1,
        amount: Number(selectedProduct.Amount),
        totalPrice: Number(selectedProduct.Amount),
        totalprice: Number(selectedProduct.Amount),
        uom: selectedProduct.uom.filter(
          (uom) => selectedProduct.amountMeasurement === uom._id,
        )[0].uomName,
        addOns: [],
      };

      return [...prev, newProduct];
    });
  };

  const orderModify = (
    orderModify: "confirm" | "modify",
    data?: changeDetails,
  ) => {
    if (orderModify === "confirm") {
      setReturnReplace(true);
    } else if (orderModify === "modify" && data) {
      const putData = {
        ...(data.difference > 0 && {
          ...orderChange,
          RemainingAmount: data?.balance < 0 ? 0 : data?.balance,
          outstanding_balance: Number(totalSOB),
          id: order.Customerid,
          paymentHistory: [
            ...(order.paymentHistory || []),
            {
              Paymentmethod: data.paymentType,
              ReceivedAmount: data.amount,
              balance: (data?.balance < 0 ? 0 : data?.balance) ?? 0,
              date: localDate,
            },
          ],
          payments: [
            {
              Paymentmethod: data.paymentType,
              ReceivedAmount: data.amount,
            },
          ],
        }),
        ...(data.difference < 0 && {
          ...orderChange,
          adjust_type:
            data.accountAdjesment === "refund" ? "refund" : "deduct_from_due",
          paymentHistory: [
            ...(order.paymentHistory || []),
            {
              Paymentmethod: data.accountAdjesment,
              ReceivedAmount: data.difference,
              balance: 0,
              date: localDate,
            },
          ],
        }),
        ...(data.difference === 0 && {
          ...orderChange,
        }),
      };
      putOrderData(order?.Orderid, putData).then((res) => {
        setEnableEdit(false);
      });
    }
  };

  return (
    <div className="w-full h-full overflow-hidden p-1">
      <div className="flex flex-col md:flex-row-reverse h-full w-full p-1 gap-2 overflow-auto">
        <OrderSidePanal
          order={
            (editableProducts.length > 0
              ? { ...(order as Order), Products: editableProducts }
              : order) as Order
          }
          received={received}
          remainingPrice={remainingPrice()}
          statusChange={(data) => statusChange(data)}
          orderStatus={orderStatus}
          setPayment={(data) => setPayment(data)}
          setPayOnly={(data) => setPayOnly(data)}
          setPrintData={(data) => setPrintData(data)}
          setLastOrderData={(data) => setLastOrderData(data)}
          setHistory={(data) => setHistory(data)}
          osb={totalSOB}
          editData={enabileEdit}
          setEditData={(data) => setEnableEdit(data)}
          setOrderChange={(data: Order) => {
            setOrderChange({ ...data, Products: editableProducts });
            orderModify("confirm");
          }}
          sendToOrder={addProductToOrder}
          product={product}
          category={category}
          productSync={() => productSync()}
          loadingPro={loadingPro}
        />
        <div
          className={`w-full lg:w-4/6 h-full border ${ThemeBasedColorMenubar()} rounded-xl p-2 shadow-inner  flex flex-col overflow-auto`}
        >
          <div className="flex items-center gap-5 justify-between">
            <div className="flex gap-4">
              <Goback />
              <h1 className="text-left text-2xl font-semibold mb-2">
                Order Items
              </h1>
            </div>
            {/* {order.OrderStatus !== "Cancelled" && (
              <div>
                {!enabileEdit ? (
                  <p className='cursor-pointer' onClick={() => setEnableEdit(!enabileEdit)}>
                    ✏️ Edit
                  </p>
                ) : (
                  order.OrderStatus === "Delivered" && (
                    <p
                      className='cursor-pointer'
                      onClick={() => {
                        setOrderStatus("Return & Refund");
                        setChangeConfimation(true);
                      }}
                    >
                      🔄 Order Return & Refund
                    </p>
                  )
                )}
              </div>
            )} */}
          </div>
          <div
            className={`hidden sm:flex w-full justify-between gap-2 ${ThemeBasedColorHeader()} p-2 rounded-t shadow-sm mb-1 text-sm font-medium`}
          >
            {[
              "S.No",
              "Product Name / 2nd Name",
              "Price (QR)",
              "Qty",
              "Units",
              "Return Qty",
              "Total (QR)",
            ].map((col, i) => (
              <div
                key={col}
                className={[
                  "font-semibold",
                  i === 0
                    ? "w-1/12 text-center"
                    : i === 1
                      ? "w-3/12"
                      : i === 4 || i === 5
                        ? "w-1/12 text-start"
                        : "w-2/12 text-end",
                ].join(" ")}
              >
                {col}
              </div>
            ))}
          </div>
          {editableProducts.map((item, index) => (
            <div key={index}>
              {/* ✅ Product Row */}
              <div className="w-full flex flex-col sm:flex-row justify-between gap-2 bg-white p-2 rounded shadow-sm mb-1 text-sm">
                {/* S.No */}
                <div className="sm:w-1/12 text-center font-semibold">
                  {index + 1}
                </div>

                {/* Name */}
                <div className="sm:w-3/12">
                  {item.productName}
                  {item.arabicword && ` / ${item.arabicword}`}
                </div>

                {/* Price */}
                {enabileEdit ? (
                  <InputBox
                    value={item.amount}
                    className="sm:w-2/12 text-right"
                    onChange={(e: any) =>
                      handleProductChange(index, "amount", e.target.value)
                    }
                  />
                ) : (
                  <div className="sm:w-2/12 text-end">
                    {Number(item.amount).toFixed(2)}
                  </div>
                )}

                {/* Qty */}
                {enabileEdit ? (
                  <InputBox
                    value={item.quantity}
                    className="sm:w-2/12 text-right"
                    onChange={(e: any) =>
                      handleProductChange(index, "quantity", e.target.value)
                    }
                  />
                ) : (
                  <div className="sm:w-2/12 text-end font-semibold">
                    {item.quantity}
                  </div>
                )}

                {/* Units */}
                <div className="sm:w-1/12 text-start font-semibold">
                  {item.uom}
                </div>

                {/* Modify Qty */}
                <div
                  className={`sm:w-1/12 text-center font-semibold  text-orange-500`}
                >
                  {order.returnHistory?.reduce(
                    (acc, p) =>
                      acc +
                      p.items.reduce(
                        (itemAcc, i) =>
                          i.productId === item.productId
                            ? itemAcc + i.returnedQty
                            : itemAcc,
                        0,
                      ),
                    0,
                  ) || 0}
                </div>

                {/* Total */}
                <div className="sm:w-2/12 text-end font-semibold">
                  {item.totalPrice.toFixed(2)}
                </div>
              </div>

              {/* ✅ AddOn Section (NOW INSIDE LOOP) */}
              {(item.addOns || []).length > 0 && (
                <div className="mx-8 mb-2 flex flex-col items-end bg-gray-50 rounded-md border border-gray-200">
                  {(item.addOns || []).map((service, sIndex) => (
                    <div
                      key={sIndex}
                      className="flex justify-between items-center px-3 py-1 border-b last:border-b-0 w-full gap-2"
                    >
                      {/* Note */}
                      <div className="flex items-center gap-2 text-gray-600 w-2/3">
                        <span className="text-gray-400">{sIndex + 1}.</span>

                        {enabileEdit ? (
                          <InputBox
                            value={service.text}
                            placeholder="Add note..."
                            className="w-full"
                            onChange={(e: any) =>
                              handleAddOnChange(
                                index,
                                sIndex,
                                "text",
                                e.target.value,
                              )
                            }
                          />
                        ) : (
                          <span>{service.text || "—"}</span>
                        )}
                      </div>

                      {/* Amount */}
                      <div className="flex items-center gap-2">
                        {enabileEdit ? (
                          <InputBox
                            value={service.amount}
                            className="w-20 text-right"
                            onChange={(e: any) =>
                              handleAddOnChange(
                                index,
                                sIndex,
                                "amount",
                                e.target.value,
                              )
                            }
                          />
                        ) : (
                          <span className="font-medium text-gray-700">
                            {Number(service.amount).toFixed(2)}
                          </span>
                        )}

                        {/* Delete AddOn */}
                        {enabileEdit && (
                          <div
                            className="cursor-pointer text-red-500"
                            onClick={() => handleDeleteAddOn(index, sIndex)}
                          >
                            <DeleteIcon />
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* ✅ Add AddOn Button (PER PRODUCT) */}
              {enabileEdit && (
                <div className="mx-8 mb-2 flex justify-end">
                  <div
                    className="cursor-pointer text-blue-500 text-sm"
                    onClick={() => handleAddAddOn(index)}
                  >
                    ➕ Alternation
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <PopupModules
        isOpen={changeConfimation}
        onClose={cancel}
        title="Status Changing Confirmation"
      >
        <div>
          <div className="text-center text-gray-700 mb-6 flex justify-center items-center gap-2">
            <p>
              <span className="font-medium">From:</span>{" "}
              <b
                className={
                  orderStatus === "Cancelled"
                    ? "text-green-600"
                    : `text-yellow-600`
                }
              >
                {order.OrderStatus}
              </b>
            </p>
            <EastIcon />
            <p>
              <span className="font-medium">To:</span>{" "}
              <b
                className={
                  ["cancel", "return & refund"].includes(
                    orderStatus?.toLowerCase(),
                  )
                    ? "text-red-600"
                    : "text-green-600"
                }
              >
                {orderStatus}
              </b>{" "}
            </p>
          </div>
          <div className="flex justify-center gap-4">
            <Button label="Cancel" variant="cancel" onClick={cancel} />
            <Button label="Confirm" onClick={confirm} />
          </div>
        </div>
      </PopupModules>
      <PaymentPopup
        totalSOB={totalSOB}
        cancel={cancel}
        order={order}
        payment={payment}
        payOnly={payOnly}
        callApi={callApi}
        orderStatus={orderStatus}
      />
      <PaymentHistory
        close={() => setHistory(false)}
        open={history}
        order={order}
      />
      <Print PrintData={PrintData} username={""} openPrint={printData} />
      <PaymentReverse
        openCancel={reversedPayment}
        closePop={() => setReceivedPayment(false)}
        ledgers={ledgers}
        order={order}
        received={received}
        close={() => {
          cancel();
          reCallGetOrder();
          setEnableEdit(false);
        }}
      />
      <ReturnReplace
        returnReplace={returnReplace}
        setReturnReplace={() => setReturnReplace(false)}
        ledgers={ledgers}
        order={order}
        orderChange={orderChange}
        changeConfirm={(data) => {
          orderModify("modify", data);
        }}
      />
    </div>
  );
}
export default SpecifiedOrderDisplay;
